// src/services/limitService.js
import { toast } from 'react-toastify';
import { apiRequestSimple } from '../utils/apiHelper';

class LimitService {
  static get apiBase() {
    return window.APP_CONFIG?.apiUrl || 'https://api.dpg.net.tr';
    //return process.env.REACT_APP_API_URL || 'https://localhost:44330';
  }

  // Define a new limit
  static defineLimit = async (limitData) => {
    const result = await apiRequestSimple('/api/limit/defineLimit', {
      method: 'POST',
      body: JSON.stringify(limitData)
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      toast.error(result.message || 'Limit could not be defined');
      return {
        success: false,
        message: result.message || 'Limit could not be defined'
      };
    }

    toast.success(result.message || 'Limit defined successfully');
    return {
      success: true,
      data: result.data,
      message: result.message
    };
  };

  // Get all limits
  static getAllLimits = async () => {
    const result = await apiRequestSimple('/api/limit/getAllLimits', {
      method: 'GET',
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      return {
        success: false,
        message: result.message || 'Limits could not be retrieved',
        data: []
      };
    }

    return {
      success: true,
      data: result.data || []
    };
  };

  // Get limit by buyer ID
  static getLimitByBuyerId = async (userId) => {
    const result = await apiRequestSimple(`/api/limit/getLimit?userId=${userId}`, {
      method: 'GET',
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      if (result.status === 404) {
        return {
          success: false,
          message: 'Limit not found',
          data: null
        };
      }
      return {
        success: false,
        message: result.message || 'Limit could not be retrieved',
        data: null
      };
    }

    return {
      success: true,
      data: result.data
    };
  };

  // Update existing limit
  static updateLimit = async (updateData) => {
    const result = await apiRequestSimple('/api/limit/updateLimit', {
      method: 'PUT',
      body: JSON.stringify(updateData)
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      toast.error(result.message || 'Limit could not be updated');
      return {
        success: false,
        message: result.message || 'Limit could not be updated'
      };
    }

    toast.success(result.message || 'Limit updated successfully');
    return {
      success: true,
      data: result.data,
      message: result.message
    };
  };

  // Get available limit (Limit - Risk)
  static getAvailableLimit = async (userId) => {
    const result = await apiRequestSimple(`/api/limit/getAvailableLimit?userId=${userId}`, {
      method: 'GET',
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      return {
        success: false,
        message: result.message || 'Available limit could not be retrieved',
        data: null
      };
    }

    return {
      success: true,
      data: result.data
    };
  };

  // Request limit (User only)
  static requestLimit = async () => {
    const result = await apiRequestSimple('/api/limit/requestLimit', {
      method: 'POST',
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      toast.error(result.message || 'Limit request could not be submitted');
      return {
        success: false,
        message: result.message || 'Limit request could not be submitted'
      };
    }

    toast.success(result.message || 'Limit request submitted successfully');
    return {
      success: true,
      data: result.data,
      message: result.message || 'Limit request submitted successfully'
    };
  };

  // Get pending limit requests (Admin only)
  static getPendingRequests = async () => {
    const result = await apiRequestSimple('/api/limit/getPendingRequests', {
      method: 'GET',
    });

    if (!result.success) {
      if (result.requiresLogout) {
        return result;
      }
      return {
        success: false,
        message: result.message || 'Pending limit requests could not be retrieved',
        data: []
      };
    }

    return {
      success: true,
      data: result.data || []
    };
  };
}

export default LimitService;
